// Images
import Logo from '../../assets/image/fl_logo_main.svg';

export default function CompanyLogo() {
	return <img className="h-8 w-auto max-w-[45vw]" src={Logo} alt="FutureLab" />;
}
